import React from 'react';
import { Switch, Route } from 'react-router';
import ACL from '../components/ACL';

import Home from '../components/Home';
import {
       Coupons,
       AddCoupon,
       EditCoupon,
       Stores,
       Users,
       EditUser,
       AddStore,
       EditStore,
       ContactUs,
       Login,
       Newsletter,
       Subscribers,
       LoggerSubscribers,
       ShowCharts,
       Events,
       AddEvent,
       EditEvent,
       PopularStores,
       AddPopularStores,
       WallCoupons,
       EditWall,
       Sliders,
       AddSlider,
       WorkWithUs,
       Categories,
       Subcategories,
       ApllicationHome,
       BulkMessages,
       AddBulkMessage,
       History,
       EditCategory,
       Comments,
       Pages,
       AddPage,
       EditPage,
       Roles,
       AddRole,
       EditRole,
       Referral,
       EditReferral,
       Notifications,
       AddNotification,
       LuckyWheels,
       AddLuckyWheel,
       EditLuckyWheel,
       LuckyWheelCoupons,
       AddLuckyWheelCoupon,
       EditLuckyWheelCoupon,
       SaleTeam,
       AddSaleTeam,
       AdsModal,
       AddAdsModal,
       EditAdsModal,
       AdsChart,
       Banner,
       AddBanner,
       EditBanner,
       BrokenCoupons,
       AddTelegramMessage,
       BreadCrumbs,
       AddBreadCrumbs,
       EditBreadCrumbs,

} from '../containers';
import SpecialCoupon from "../containers/SpecialCoupon";
import ExpiredCoupon from "../containers/ExpiredCoupon";
import AddJob from "../containers/Jobs/add";
import EditJob from "../containers/Jobs/edit";
import Jobs from "../containers/Jobs/index";
import Products from "../containers/Products";
import EditProduct from "../containers/Products/edit";
import FooterBanner from '../containers/FooterBanner';
import AddFooterBanner from '../containers/FooterBanner/add';
import EditFooterBanner from '../containers/FooterBanner/edit';

let routes = (
       <ACL component={Switch}>
              <Route exact path="/" component={Home} />
              <Route path={`/special-coupons`} has_permission="coupons_management|coupons_list" exact component={SpecialCoupon} />
              <Route path={`/expired-coupons`} has_permission="coupons_management|coupons_list" exact component={ExpiredCoupon} />
              <Route path={`/coupons`} has_permission="coupons_management|coupons_list" exact component={Coupons} />
              <Route path={`/coupons/add`} has_permission="coupons_management|coupons_add" component={AddCoupon} />
              <Route path={`/coupons/edit/:id`} has_permission="coupons_management|coupons_edit" component={EditCoupon} />

              <Route path={`/stores`} has_permission="stores_management|stores_list" exact component={Stores} />
              <Route path={`/stores/add`} has_permission="stores_management|stores_add" component={AddStore} />
              <Route path={`/stores/edit/:id`} has_permission="stores_management|stores_edit" component={EditStore} />

              <Route path={`/users`} has_permission="users_management|users_list|acl_management" exact component={Users} />
              <Route path={`/users/edit/:id`} has_permission="users_management|users_edit|acl_management" component={EditUser} />

              <Route path={`/events`} has_permission="events_management|events_list" exact component={Events} />
              <Route path={`/events/add`} has_permission="events_management|events_add" component={AddEvent} />
              <Route path={`/events/edit/:id`} has_permission="events_management|events_edit" component={EditEvent} />
              <Route path={`/contact-us`} has_permission="contact_management|contact_list" component={ContactUs} />
              <Route path={`/newsletter`} has_permission="newsletter_management|newsletter_list"
                     component={Newsletter} />
              <Route path={`/subscribers`} has_permission="subscribers_management|subscribers_list"
                     component={Subscribers} />
              <Route path={`/login`} component={Login} />

              <Route path={`/logger/newsletters`}
                     has_permission="newsletters_logger_management|newsletters_logger_list" exact
                     component={LoggerSubscribers} />
              <Route path={`/logger/newsletters/:id`} has_permission="newsletters_logger_management|newsletters_logger_edit"
                     component={ShowCharts} />

              <Route path={`/popularstores`} has_permission="popularstores_management|popularstores_list" exact
                     component={PopularStores} />
              <Route path={`/popular-stores/add`} has_permission="popularstores_management|popularstores_add" component={AddPopularStores} />

              <Route path={`/wall`} has_permission="wall_management|wall_list" exact component={WallCoupons} />
              <Route path={`/wall/edit/:id`} has_permission="wall_management|wall_edit" component={EditWall} />

              <Route path={`/sliders`} has_permission="sliders_management|sliders_list" exact component={Sliders} />
              <Route path={`/sliders/add`} has_permission="sliders_management|sliders_add" component={AddSlider} />

              <Route path={`/comments`} has_permission="comments_management|comments_list" exact component={Comments} />
              {/* <Route path={`/comments/edit`} component={EditComment} /> */}

              <Route path={`/app-sliders`} has_permission="application_sliders_management|application_sliders_list" exact
                     component={props => <Sliders appSlider={true} {...props} />} />
              <Route path={`/app-sliders/add`} has_permission="application_sliders_management|application_sliders_add"
                     component={props => <AddSlider appSlider={true} {...props} />} />

              {/* <Route path={`/app-advertising`} exact component={AppAdvertising} /> */}
              <Route path={'/app-home'} has_permission="application" exact component={ApllicationHome} />


              <Route path={`/work-with-us`} has_permission="workus_management|workus_list" exact component={WorkWithUs} />

              <Route path={`/categories`} has_permission="categories_management|categories_list" exact component={Categories} />
              <Route path={`/categories/:id`} has_permission="categories_management|categories_list|categories_edit" exact
                     component={Subcategories} />
              <Route path={`/categories/edit/:id`} has_permission="categories_management|categories_edit" exact component={EditCategory} />

              <Route path={`/bulk-messages`} has_permission="bulk-messages_management|bulk-messages_list" exact
                     component={BulkMessages} />
              <Route path={`/bulk-messages/add`} has_permission="bulk-messages_management|bulk-messages_add" component={AddBulkMessage} />

              <Route path={`/history/:type?/:id?`} has_permission="history_management|history_list" component={History} />

              <Route path={`/pages`} has_permission="pages_management|pages_list" exact component={Pages} />
              <Route path={`/pages/add`} has_permission="pages_management|pages_add" exact component={AddPage} />
              <Route path={`/pages/edit/:slug`} has_permission="pages_management|pages_edit" exact component={EditPage} />

              <Route path={`/acl/roles`} has_permission="acl_management" exact component={Roles} />
              <Route path={`/acl/roles/add`} has_permission="acl_management|acl_add" exact component={AddRole} />
              <Route path={`/acl/roles/edit/:id`} has_permission="acl_management|acl_edit" exact component={EditRole} />
              <Route path={`/referral`} has_permission="referral_management|referral_list" exact component={Referral} />
              <Route path={`/referral/edit/:id`} has_permission="referral_management|referral_edit" exact component={EditReferral} />

              <Route path={`/notifications`} has_permission="notification_management|notification_add" exact component={Notifications} />
              <Route path={`/notifications/add`} has_permission="notification_management|notification_add" exact component={AddNotification} />

              <Route path={`/lucky_wheels`} has_permission="lucky_wheels_management|lucky_wheels_list" exact component={LuckyWheels} />
              <Route path={`/lucky_wheels/add`} has_permission="lucky_wheels_management|lucky_wheels_add" component={AddLuckyWheel} />
              <Route path={`/lucky_wheels/edit/:id`} has_permission="lucky_wheels_management|lucky_wheels_edit" component={EditLuckyWheel} />

              <Route path={`/lucky_wheels/coupons/:lucky_wheel_id`} has_permission="lucky_wheels_management|lucky_wheels_list" exact component={LuckyWheelCoupons} />
              <Route path={`/lucky_wheels/coupons/:lucky_wheel_id/add`} has_permission="lucky_wheels_management|lucky_wheels_add" component={AddLuckyWheelCoupon} />
              <Route path={`/lucky_wheels/coupons/:lucky_wheel_id/edit/:id`} has_permission="lucky_wheels_management|lucky_wheels_edit" component={EditLuckyWheelCoupon} />

              <Route path={`/jobs`} exact component={Jobs} />
              <Route path={`/jobs/create`} component={AddJob} />
              <Route path={`/jobs/edit/:id`} component={EditJob} />

              <Route path={`/products`} exact component={Products} />
              <Route path={`/products/edit/:id`} component={EditProduct} />

              <Route path={`/sale-team`} exact component={SaleTeam} />
              <Route path={`/sale-team/add`} exact component={AddSaleTeam} />
              <Route path={`/ads-modal`} exact component={AdsModal} />
              <Route path={`/ads-modal/add`} exact component={AddAdsModal} />
              <Route path={`/ads-modal/edit/:id`} component={EditAdsModal} />
              <Route path={`/ads-modal/records/:id`} component={AdsChart} />


              <Route path={`/banner`} exact component={Banner} />
              <Route path={`/banner/add`} exact component={AddBanner} />
              <Route path={`/banner/edit/:id`} component={EditBanner} />

              <Route path={`/footer-banner`} exact component={FooterBanner} />
              <Route path={`/footer-banner/add`} exact component={AddFooterBanner} />
              <Route path={`/footer-banner/edit/:id`} component={EditFooterBanner} />

              <Route path={`/broken`} exact component={BrokenCoupons} has_permission="broken_coupons_report" />
              <Route path={`/telegram`} exact component={AddTelegramMessage} has_permission="telegram_message" />

              <Route path={`/bread-crumbs`} exact component={BreadCrumbs} />
              <Route path={`/bread-crumbs/add`} exact component={AddBreadCrumbs} />
              <Route path={`/bread-crumbs/edit/:id`} component={EditBreadCrumbs} />



       </ACL>
);

export default routes



// WEBPACK FOOTER //
// ./src/routes/index.js